

































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import BpcSection from '@shared/components/forms/inputs/section/section.vue';
import BpcMultiSelect from '@shared/components/forms/inputs/multi-select/multi-select.vue';
import BpcSelect from '@shared/components/forms/inputs/select/select.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import FieldWrapper from '@shared/components/forms/inputs/field-wrapper/field-wrapper.vue';

import {
  MultiplayerBooking,
  MultiplayerBookingErrorsObject,
  Player,
} from '@bookings/interfaces/multiplayer-booking';
import { Discipline } from '@centers/interfaces/discipline';
import { BookingMultiplayerFields } from '@/config/bookings';
import BpcMultiplayerBookingPlayerCard from '@bookings/components/booking-multiplayer/multiplayer-booking-player-card.vue';
import { Contact } from '@contacts/interfaces/contact';

@Component({
  name: 'bpc-multiplayer-booking-section',
  components: {
    BpcSection,
    BpcMultiSelect,
    BpcSelect,
    BpcMultiplayerBookingPlayerCard,
    'bpc-input': Input,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class MultiplayerBookingSection extends Vue {
  @Prop(Object) readonly value: MultiplayerBooking;
  @Prop(Object) readonly discipline: Discipline;
  @Prop(Object) readonly owner: Contact;
  @Prop(Boolean) readonly disabled: boolean;

  // DATA
  errorsObject: MultiplayerBookingErrorsObject = {};

  // COMPUTED
  get formModel() {
    return this.value;
  }

  set formModel(value: MultiplayerBooking) {
    this.$emit('input', value);
  }

  get fieldsConfig() {
    return BookingMultiplayerFields;
  }

  get numberOfPlayerFieldConfig() {
    const { number_of_players } = this.fieldsConfig;
    const disciplineOptions = this.discipline?.number_of_players ?? [];

    const filteredOptions = disciplineOptions.length
      ? number_of_players.allOptions.filter(option => disciplineOptions.includes(option.value))
      : [];
    const options = [...number_of_players.options, ...filteredOptions];
    return { ...number_of_players, options };
  }
  get bookingLevel(): string {
    return this.formModel.discipline_level ?? '';
  }

  get numberOfGuests(): number {
    const players = this.formModel?.players ?? [];
    return players.filter(player => player.type === 'guest').length;
  }

  get totalPrice(): number {
    const players = this.formModel?.players ?? [];
    return players
      .filter(player => !player.paid_with_subscription) // Not sure about this
      .reduce((acc, player) => acc + player.price, 0);
  }

  getPlayerItemKey(player: Player) {
    return ['player-item', player.number, player?.contact?.id].join('-');
  }

  assignOwnerAsFirstPlayer(): void {
    if (this.formModel.number_of_players) {
      const playerValue = {
        playerNumber: 0,
        type: 'owner',
        status: null,
        contact: this.owner,
      };
      this.$set(this.formModel.players, 0, playerValue);
    }
  }

  @Watch('formModel.number_of_players')
  onChangeNumberOfPlayer() {
    const players = this.formModel.players;
    const numberOfPlayers = this.formModel.number_of_players;
    if (players.length === 0) {
      players[0] = {
        number: 0,
        type: 'owner',
        status: null,
        payment_status: null,
        contact: this.owner,
        contact_id: this.owner?.id,
        price: 0,
        credit_price: 0,
        paid_by_guarantee: false,
        paid_with: null,
        paid_with_subscription: false,
      };
    }
    if (players.length < numberOfPlayers) {
      // Ajouter des éléments jusqu'à atteindre la taille désirée
      for (let i = players.length; i < numberOfPlayers; i++) {
        players.push({
          number: i,
          type: null,
          status: null,
          payment_status: null,
          contact: null,
          contact_id: null,
          price: 0,
          credit_price: 0,
          paid_by_guarantee: false,
          paid_with: null,
          paid_with_subscription: false,
        });
      }
    } else if (players.length > numberOfPlayers) {
      // Supprimer les éléments en trop
      players.splice(numberOfPlayers);
    }
  }

  @Watch('owner.id')
  onChangeOwner() {
    this.assignOwnerAsFirstPlayer();
  }
}
